import { LoaderCircle, RotateCcw, X } from 'lucide-react';
import { STATUS_LABEL, type FileQueue } from '../../tasks/FilePicker';
import { FileTypeIcon } from './FileTypeIcon';

const SMALL_BUTTON = 'inline-flex min-h-11 min-w-11 items-center justify-center gap-1 rounded-md px-2 text-xs font-medium '
  + 'transition-colors lg:min-h-7 lg:min-w-7';

/**
 * The files on their way to Hana (§7.1): one chip each while it uploads and the server checks it. A chip leaves once
 * its job exists (D117); a failed one keeps "Thử lại" and "Bỏ" so the rest of its pick can still go.
 */
export function UploadTray({ queue }: { queue: FileQueue }) {
  if (queue.files.length === 0) return null;
  return (
    <ul aria-label="Tệp đang gửi" className="flex flex-col gap-1.5">
      {queue.files.map((f) => {
        const failed = f.status === 'failed';
        return (
          <li key={f.localId}
            className="flex items-center gap-2 rounded-lg border border-[hsl(var(--h-border))] bg-[hsl(var(--h-card))] py-1 pl-2 pr-1">
            <FileTypeIcon mediaType={f.file.type} filename={f.file.name} />
            <div className="min-w-0 flex-1 leading-tight">
              <p className="truncate text-sm font-semibold text-[hsl(var(--h-card-foreground))]" title={f.file.name}>{f.file.name}</p>
              <p role={failed ? 'status' : undefined}
                className={failed ? 'text-xs text-[hsl(var(--h-error-fg))]' : 'flex items-center gap-1 text-xs text-[hsl(var(--h-muted-foreground))]'}>
                {!failed && f.status !== 'verified' && <LoaderCircle className="size-3 animate-spin motion-reduce:animate-none" aria-hidden="true" />}
                {failed ? (f.error ?? STATUS_LABEL.failed) : STATUS_LABEL[f.status]}
              </p>
            </div>
            {failed && (
              <button type="button" onClick={() => queue.retry(f.localId)}
                className={`${SMALL_BUTTON} text-[hsl(var(--h-primary))] hover:bg-[hsl(var(--h-primary)/0.1)]`}>
                <RotateCcw className="size-3.5" aria-hidden="true" />
                Thử lại<span className="sr-only">{` tệp ${f.file.name}`}</span>
              </button>
            )}
            <button type="button" onClick={() => queue.remove(f.localId)} title="Bỏ tệp"
              className={`${SMALL_BUTTON} text-[hsl(var(--h-muted-foreground))] hover:bg-[hsl(var(--h-error-soft))] hover:text-[hsl(var(--h-error-fg))]`}>
              <X className="size-3.5" aria-hidden="true" />
              <span className="sr-only">{`Bỏ tệp ${f.file.name}`}</span>
            </button>
          </li>
        );
      })}
    </ul>
  );
}
